import { render, staticRenderFns } from "./BtnExcluirLicitacao.vue?vue&type=template&id=01d7aeeb"
import script from "./BtnExcluirLicitacao.vue?vue&type=script&lang=js"
export * from "./BtnExcluirLicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports